// 所有加入购物车的键值对
export const glassTypes = "id[2]";
export const glassTypeVale = {
    distance: 1,
    intermediate: 3,
    multifocla: 4,
    near: 2,
    nonRx: 268,
    frameOnly: 269,
    frameSunNonRx: 300,
};
export const decentered = "id[94]";

export const decenteredValue = 403;

export const multiFocus = "id[2]";
export const multiFocusV = 4;

export const bifocal = "id[27]";

export const bifocalV = 278;

export const bifocalTop = "id[210]";

export const bifocalTopV = {
    roundTop: 50,
    flatTop: 51,
};

export const standardProgressive = "id[28]";

export const standardProgressiveV = 279;

export const advancedProgressive = "id[12]";

export const advancedProgressiveV = 703;

export const lensType = "id[200]";

export const lensTypeV = {
    brownDark: 900,
    BrownLight: 901,
    GreyDark: 902,
    GreyLight: 903,
    GreenDark: 904,
    BlueLight: 905,
    PurpleLight: 906,
    BrownGradient: 907,
    GreyGradient: 908,
    GreenGradient: 909,
    BurgundyGradient: 910,
    PurpleGradient: 911,
    PurpleDark: 912,
    BlueDark: 913,
    GreenLight: 914,
};

export const advancedPhoto = "id[201]";

export const advancedPhotoV = 920;

export const PhotoTrans = "id[204]";

export const PhotoTransV = 921;

export const polarized = "id[205]";

export const polarizedV = {
    Grey: 930,
    Brown: 931,
    Green: 932,
};

export const blueLight = "id[206]";

export const blueLightV = 1000;

export const noColor = "id[22]";

export const noColorV = 273;
